export default __webpack_public_path__ + "static/media/icon-sprite-sheet.df15473f.svg";